import React from "react";
import { formatDate } from "../../../utils/date";

export type RevocationDisclaimerProps = {
  status?: string | null;
  isRevoked?: boolean;
  revocationCategory?: string | null;
  revocationReason?: string | null;
  revokedBy?: string | null;
  revocationDate?: string | Date | null;
};

export const RevocationDisclaimer: React.FC<RevocationDisclaimerProps> = ({
  status,
  isRevoked,
  revocationCategory,
  revocationReason,
  revokedBy,
  revocationDate,
}) => {
  const isRevokedStatus = isRevoked || status?.trim().toLowerCase().startsWith("revoked");
  if (!isRevokedStatus) return null;

  return (
    <div className="mb-6 rounded-lg border border-gray-200 border-l-4 border-l-red-600 bg-white p-4 shadow-sm">
      {/* Top Metadata Row */}
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2.5">
        <div className="flex flex-wrap items-center gap-2 text-xs">
          <span className="font-bold text-red-700 text-sm">Application Revoked</span>
          <span className="bg-red-50 text-red-700 border border-red-200 px-2 py-0.5 rounded text-xs font-semibold">
            {status || "Revoked"}
          </span>
          <span className="text-gray-300">|</span>
          <span className="text-gray-600">
            Category: <strong className="text-gray-900 font-semibold">{revocationCategory || "Not Specified / Legacy Revocation"}</strong>
          </span>
          {revokedBy && (
            <>
              <span className="text-gray-300">|</span>
              <span className="text-gray-600">
                Action By: <strong className="text-gray-900 font-semibold">{revokedBy}</strong>
              </span>
            </>
          )}
        </div>
        {revocationDate && (
          <span className="text-xs text-gray-500 font-medium">
            Revoked on: <strong className="text-gray-800">{formatDate(revocationDate)}</strong>
          </span>
        )}
      </div>

      {/* Description / Remarks */}
      <div className="bg-gray-50 rounded-md px-3.5 py-2.5 text-sm text-gray-800 font-medium mb-2 border border-gray-100">
        <span className="text-xs text-gray-500 font-bold uppercase tracking-wider block mb-0.5">
          Remarks / Reason:
        </span>
        <p className="whitespace-pre-line text-gray-800 font-medium">
          {revocationReason || "No additional description provided."}
        </p>
      </div>

      {/* Footer Notice */}
      <p className="text-xs text-gray-500 italic">
        Notice: This application is permanently frozen in read-only mode. All further reviews, resubmissions, and payment actions are disabled.
      </p>
    </div>
  );
};
